import styled from "styled-components";

export const ButtonStyled = styled.div`

    .Polaris-Button {
        width: 100%;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: space-between;
    }

    img {
        object-fit: cover;
    }
`

export const StyledBox = styled.div`
    &>.Polaris-Box {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`